<template>
  <div class="electric-quantity" id="electric-quantity">
    <div class="right-btn">
      <span :class="[active == 1 ? 'active' : '']" @click="dateClick(1)"
        >日</span
      >
      <span>/</span>
      <span :class="[active == 2 ? 'active' : '']" @click="dateClick(2)"
        >月</span
      >
      <span>/</span>
      <span :class="[active == 3 ? 'active' : '']" @click="dateClick(3)"
        >年</span
      >
    </div>
    <div class="electric-bottom">
      <div class="electric-bottom-l">
        <div class="left">
          <div class="l-box-t">
            <div class="content-top">
              <el-tooltip
                class="item"
                placement="top"
                :open-delay="delay"
                popper-class="atooltip"
              >
                <div slot="content">充电枪总数=充电枪总数量</div>
                <div class="text">充电枪总数 (支)</div>
              </el-tooltip>
              <div class="number">{{ total_chargers | twoDecimal }}</div>
            </div>
          </div>
          <div class="l-box-b">
            <div class="content-top">
              <el-tooltip
                class="item"
                placement="top"
                :open-delay="delay"
                popper-class="atooltip"
              >
                <div slot="content">充电时长=订单充电时长总和(包含今日)</div>
                <div class="text">充电时长 (小时)</div>
              </el-tooltip>
              <div class="number">{{ chargetime | twoDecimal }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="r-box-t">
            <div class="content-top">
              <el-tooltip
                class="item"
                placement="top"
                :open-delay="delay"
                popper-class="atooltip"
              >
                <div slot="content">总功率=充电枪额定功率总和</div>
                <div class="text">总功率 (KW)</div>
              </el-tooltip>
              <div class="number">{{ total_powers | twoDecimal }}</div>
            </div>
          </div>
          <div class="r-box-b">
            <div class="content-top">
              <el-tooltip
                class="item"
                placement="top"
                :open-delay="delay"
                popper-class="atooltip"
              >
                <div slot="content">充电量=订单充电量总和(包含今日)</div>
                <div class="text">充电量 (度)</div>
              </el-tooltip>
              <div class="number">{{ chargepower | twoDecimal }}</div>
            </div>
          </div>
        </div>
        <div class="cross-h"></div>
        <div class="cross-s"></div>
        <div style="clear: both"></div>
      </div>
      <div class="electric-bottom-c"></div>
      <div class="electric-bottom-r">
        <div class="box-l">
          <div class="box-l-t">
            <p v-if="isShow">在线率=(空闲+就绪+故障+充电中+预约)枪数/总枪数</p>
            <div class="content-bottom">
              <div
                style="width: 100%; height: 100%"
                id="number1-echarts2"
              ></div>
            </div>
          </div>
          <div class="box-l-b">
            <p v-if="isShow1">充电率=充电中枪数/总枪数</p>
            <div class="content-bottom">
              <div
                style="width: 100%; height: 100%"
                id="number2-echarts2"
              ></div>
            </div>
          </div>
        </div>
        <div class="box-r">
          <div class="box-l-t">
            <p v-if="isShow2">故障率=(故障+离线)枪数/总枪数</p>
            <div class="content-bottom">
              <div
                style="width: 100%; height: 100%"
                id="number3-echarts2"
              ></div>
            </div>
          </div>
          <div class="box-l-b">
            <p v-if="isShow3">结算率=已完成订单数/总订单数</p>
            <div class="content-bottom">
              <div
                style="width: 100%; height: 100%"
                id="number4-echarts2"
              ></div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      delay: 1000,
      active: 1,
      width: "",
      list: [],
      total_chargers: "", //充电桩总数
      total_powers: "", //总功率
      today_chargetime: "", //今日充电时长
      month_chargetime: "", //本月充电时长
      year_chargetime: "", //今年充电时长
      chargetime: "", //充电时长
      today_chargepower: "", //今日充电量
      month_chargepower: "", //本月充电量
      year_chargepower: "", //今年充电量
      chargepower: "", //充电量
      online_rate: "", //在线率(%)
      charging_rate: "", //即时使用率(%)
      fault_rate: "", //故障率(%)
      today_completed_rate: "", //今日结算率(%)
      month_completed_rate: "", //本月结算率(%)
      year_completed_rate: "", //今年结算率(%)
      completed_rate: "", //今年结算率(%)
    };
  },
  mounted() {
    let o = document.getElementById("electric-quantity");
    this.$nextTick(function () {
      if (this.$store.state.getTotalState != "") {
        this.getData();
      }

      // this.getData();
    });
  },
  methods: {
    getData() {
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action:"getTotalState",
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
      let su = this.$store.state.getTotalState;
      if (su.data.code == 1) {
        this.list = su.data.list;
        for (let i in this.list) {
          if (this.list[i].type == "total_chargers") {
            this.total_chargers = this.list[i].value;
          } else if (this.list[i].type == "total_powers") {
            this.total_powers = this.list[i].value;
          } else if (this.list[i].type == "today_chargetime") {
            this.chargetime = this.list[i].value;
            this.today_chargetime = this.list[i].value;
          } else if (this.list[i].type == "month_chargetime") {
            this.month_chargetime = this.list[i].value;
          } else if (this.list[i].type == "year_chargetime") {
            this.year_chargetime = this.list[i].value;
          } else if (this.list[i].type == "today_chargepower") {
            this.today_chargepower = this.list[i].value;
            this.chargepower = this.list[i].value;
          } else if (this.list[i].type == "month_chargepower") {
            this.month_chargepower = this.list[i].value;
          } else if (this.list[i].type == "year_chargepower") {
            this.year_chargepower = this.list[i].value;
          } else if (this.list[i].type == "online_rate") {
            this.online_rate = this.list[i].value;
          } else if (this.list[i].type == "charging_rate") {
            this.charging_rate = this.list[i].value;
          } else if (this.list[i].type == "fault_rate") {
            this.fault_rate = this.list[i].value;
          } else if (this.list[i].type == "today_completed_rate") {
            this.today_completed_rate = this.list[i].value;
            this.completed_rate = this.list[i].value;
          } else if (this.list[i].type == "month_completed_rate") {
            this.month_completed_rate = this.list[i].value;
          } else if (this.list[i].type == "year_completed_rate") {
            this.year_completed_rate = this.list[i].value;
          }
        }
        // this.chargetime = today_chargetime;
        this.drawNumber1Echarts(this.online_rate);
        this.drawNumber2Echarts(this.charging_rate);
        this.drawNumber3Echarts(this.fault_rate);
        this.drawNumber4Echarts(this.completed_rate);
      } else if (su.data.code == 0) {
        this.$message.error("数据库操作失败");
      } else if (su.data.code == 300) {
        localStorage.clear();
        this.$router.push("/login");
        // this.$message.error(su.data.message);
      } else if (su.data.code == 900) {
      } else {
        this.$message.error(su.data.message);
      }
      // })
      // .catch(err => {
      // });
    },
    drawNumber1Echarts(data) {
      let echart = echarts.init(document.getElementById("number1-echarts2"));
      // data = data.substring(0,data.indexOf(".")+3);
      data = Math.round(data);
      var assistdata = [];
      for (let i = 0; i < 50; i++) {
        assistdata.push({
          name: "1",
          value: 1,
        });
      }
      var option = {
        title: {},
        color: ["#00101d", "#FF8033"],
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        graphic: [
          {
            type: "text",
            left: "center",
            top: "35%",
            z: 2,
            zlevel: 100,
            style: {
              text: "在线率",
              fill: "#6AC5FC",
              font: "bold 14px Microsoft YaHei",
              fontSize: 14,
            },
          },
          {
            type: "text",
            left: "center",
            top: "55%",
            z: 2,
            zlevel: 100,
            style: {
              text: data + "%",
              fill: "#6AC5FC",
              fontWeight: 700,
              fontSize: 20,
            },
            onmouseover() {
              that.isShow = true;
            },
            onmouseout() {
              that.isShow = false;
            },
          },
        ],
        series: [
          {
            name: "在线率",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["#FF8033"],
            hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              show: false,
              borderColor: "#0C202B",
              borderWidth: 4,
            },
            data: assistdata,
          },
          {
            name: "百分比",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["transparent", "#00101d"],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                name: "使用",
                value: data,
              },
              {
                name: "未使用",
                value: 100 - data,
              },
            ],
          },
        ],
      };

      echart.setOption(option);
      // clearInterval(this.timer4);
      // this.timer4 = setInterval(() => {
      //   setTimeout(function (){
      //     window.addEventListener("resize", function() {
      //       return (() => {
      //         echart.resize();
      //       })();
      //     });
      //   },0)
      // }, 100);
    },
    drawNumber2Echarts(data) {
      let echart = echarts.init(document.getElementById("number2-echarts2"));
      // data = data.substring(0,data.indexOf(".")+3);
      data = Math.round(data);
      var assistdata = [];
      for (let i = 0; i < 50; i++) {
        assistdata.push({
          name: "1",
          value: 1,
        });
      }
      var option = {
        title: {},
        color: ["#F9BC14", "#00101d"],
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        graphic: [
          {
            type: "text",
            left: "center",
            top: "35%",
            z: 2,
            zlevel: 100,
            style: {
              text: "充电率",
              fill: "#6AC5FC",
              font: "bold 14px Microsoft YaHei",
              fontSize: 14,
            },
               onmouseover() {
                that.isShow = true;
            },
            onmouseout() {
              that.isShow = false;
            },
          },
          {
            type: "text",
            left: "center",
            top: "55%",
            z: 2,
            zlevel: 100,
            style: {
              text: data + "%",
              fill: "#6AC5FC",
              fontWeight: 700,
              fontSize: 20,
            },
          },
        ],
        series: [
          {
            name: "充电率",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["#F9BC14"],
            hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              show: false,
              borderColor: "#0C202B",
              borderWidth: 4,
            },
            data: assistdata,
          },
          {
            name: "百分比",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["transparent", "#00101d"],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                name: "未使用",
                value: data,
              },
              {
                name: "使用",
                value: 100 - data,
              },
            ],
          },
        ],
      };

      echart.setOption(option);
      // clearInterval(this.timer3);
      // this.timer3 = setInterval(() => {
      //   setTimeout(function (){
      //     window.addEventListener("resize", function() {
      //       return (() => {
      //         echart.resize();
      //       })();
      //     });
      //   },0)
      // }, 100);
    },
    drawNumber3Echarts(data) {
      let echart = echarts.init(document.getElementById("number3-echarts2"));

      // data = data.substring(0,data.indexOf(".")+3);
      data = Math.round(data);
      var assistdata = [];
      for (let i = 0; i < 50; i++) {
        assistdata.push({
          name: "1",
          value: 1,
        });
      }
      var option = {
        title: {},
        color: ["#01C756", "#00101d"],
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        graphic: [
          {
            type: "text",
            left: "center",
            top: "35%",
            z: 2,
            zlevel: 100,
            style: {
              text: "故障率",
              fill: "#6AC5FC",
              font: "bold 14px Microsoft YaHei",
              fontSize: 14,
            },
               onmouseover() {
                that.isShow = true;
            },
            onmouseout() {
              that.isShow = false;
            },
          },
          {
            type: "text",
            left: "center",
            top: "55%",
            z: 2,
            zlevel: 100,
            style: {
              text: data + "%",
              fill: "#6AC5FC",
              fontWeight: 700,
              fontSize: 20,
            },
          },
        ],
        series: [
          {
            name: "故障率",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["#01C756"],
            hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              show: false,
              borderColor: "#0C202B",
              borderWidth: 4,
            },
            data: assistdata,
          },
          {
            name: "百分比",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["transparent", "#00101d"],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                name: "未使用",
                value: data,
              },
              {
                name: "使用",
                value: 100 - data,
              },
            ],
          },
        ],
      };

      echart.setOption(option);
      // clearInterval(this.timer2);
      // this.timer2 = setInterval(() => {
      //   setTimeout(function (){
      //     window.addEventListener("resize", function() {
      //       return (() => {
      //         echart.resize();
      //       })();
      //     });
      //   },0)
      // }, 100);
    },
    drawNumber4Echarts(data) {
      let echart = echarts.init(document.getElementById("number4-echarts2"));
      // data = data.substring(0,data.indexOf(".")+3);
      data = Math.round(data);
      var assistdata = [];
      for (let i = 0; i < 50; i++) {
        assistdata.push({
          name: "1",
          value: 1,
        });
      }
      var option = {
        title: {},
        color: ["#5FC7FE", "#00101d"],
        legend: {
          orient: "vertical",
          x: "left",
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{d}%",
          show: false,
        },
        grid: {},
        graphic: [
          {
            type: "text",
            left: "center",
            top: "35%",
            z: 2,
            zlevel: 100,
            style: {
              text: "结算率",
              fill: "#6AC5FC",
              font: "bold Microsoft YaHei",
              fontSize: 14,
            },
               onmouseover() {
                that.isShow = true;
            },
            onmouseout() {
              that.isShow = false;
            },
          },
          {
            type: "text",
            left: "center",
            top: "55%",
            z: 2,
            zlevel: 100,
            style: {
              text: data + "%",
              fill: "#6AC5FC",
              fontWeight: 700,
              fontSize: 20,
            },
          },
        ],
        series: [
          {
            name: "结算率",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["#5FC7FE"],
            hoverAnimation: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              show: false,
              borderColor: "#0C202B",
              borderWidth: 4,
            },
            data: assistdata,
          },
          {
            name: "百分比",
            type: "pie",
            silent: true,
            radius: ["75%", "95%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            color: ["transparent", "#00101d"],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                name: "未使用",
                value: data,
              },
              {
                name: "使用",
                value: 100 - data,
              },
            ],
          },
        ],
      };

      echart.setOption(option);
      // clearInterval(this.timer);
      // this.timer = setInterval(() => {
      //   setTimeout(function (){
      //     window.addEventListener("resize", function() {
      //       return (() => {
      //         echart.resize();
      //       })();
      //     });
      //   },0)
      // }, 100);
    },
    dateClick(num) {
      this.active = num;
      if (num == 1) {
        this.completed_rate = this.today_completed_rate;
        this.drawNumber1Echarts(this.online_rate);
        this.drawNumber2Echarts(this.charging_rate);
        this.drawNumber3Echarts(this.fault_rate);
        this.drawNumber4Echarts(this.completed_rate);
        this.chargetime = this.today_chargetime;
        this.chargepower = this.today_chargepower;
      } else if (num == 2) {
        this.completed_rate = this.month_completed_rate;
        this.drawNumber4Echarts(this.completed_rate);
        this.chargetime = this.month_chargetime;
        this.chargepower = this.month_chargepower;
      } else if (num == 3) {
        this.completed_rate = this.year_completed_rate;
        this.drawNumber4Echarts(this.completed_rate);
        this.chargetime = this.year_chargetime;
        this.chargepower = this.year_chargepower;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.electric-quantity {
  height: 100%;
  overflow: hidden;
  .right-btn {
    text-align: right;
    margin-right: 27%;
    z-index: 999;
    margin-top: 12px;
    margin-bottom: 12px;
    span {
      color: #006eae;
      cursor: pointer;
    }
    span.active {
      color: #abe3fe;
    }
  }
  .electric-bottom {
    position: relative;
    height: 82%;
    .electric-bottom-l {
      width: 48%;
      height: 100%;
      float: left;
      position: relative;
      margin-top: 20px;
      .left {
        width: 50%;
        height: 100%;
        float: left;
        .l-box-t {
          height: 50%;
          .content-top {
            // margin-bottom: 10px;
            .text {
              color: #6ac5fc;
              font-size: 16px;
            }
            .number {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #5fc8ff;
              font-size: 28px;
              margin-top: 10px;
            }
          }
        }
        .l-box-b {
          .content-top {
            // margin-bottom: 10px;
            .text {
              color: #6ac5fc;
              font-size: 16px;
            }
            .number {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #5fc8ff;
              font-size: 28px;
              margin-top: 10px;
            }
          }
        }
      }
      .right {
        width: 50%;
        height: 100%;
        float: right;
        .r-box-t {
          height: 50%;
          .content-top {
            // margin-bottom: 10px;
            .text {
              color: #6ac5fc;
              font-size: 16px;
            }
            .number {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #5fc8ff;
              font-size: 28px;
              margin-top: 10px;
            }
          }
        }
        .r-box-b {
          .content-top {
            // margin-bottom: 10px;
            .text {
              color: #6ac5fc;
              font-size: 16px;
            }
            .number {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #5fc8ff;
              font-size: 28px;
              margin-top: 10px;
            }
          }
        }
      }
      .cross-h {
        position: absolute;
        top: 35%;
        width: 100%;
        height: 1px;
        background: url("../../../assets/img/line-h.png") no-repeat;
        background-size: 100% 100%;
      }
      .cross-s {
        position: absolute;
        left: 50%;
        top: -10%;
        width: 1px;
        height: 100%;
        background: url("../../../assets/img/line.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .electric-bottom-c {
      float: left;
      width: 1px;
      height: 100%;
      background: url("../../../assets/img/line.png") no-repeat;
      background-size: 100% 100%;
      margin-top: -10px;
    }
    .electric-bottom-r {
      width: 50%;
      height: 100%;
      float: left;
      position: relative;
      .box-l {
        width: 50%;
        height: 100%;
        float: left;
        .box-l-t {
          height: 50%;
          position: relative;
           p {
            position: absolute;
            font-size: 10px;
            color: white;
            z-index: 999;
            width: 200px;
            top: -10px;
            background: rgba($color: #303133, $alpha: 0.3);
            border-radius: 4px;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .content-bottom {
            height: 100%;
          }
        }
        .box-l-b {
          position: relative;
          height: 50%;
           p {
            position: absolute;
            font-size: 10px;
            color: white;
            z-index: 999;
            width: 200px;
            top: -10px;
            background: rgba($color: #303133, $alpha: 0.3);
            border-radius: 4px;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .content-bottom {
            height: 100%;
          }
        }
      }
      .box-r {
        width: 50%;
        height: 100%;
        float: right;
        .box-l-t {
          height: 50%;
          position: relative;
           p {
            position: absolute;
            font-size: 10px;
            color: white;
            z-index: 999;
            width: 200px;
            top: -10px;
            background: rgba($color: #303133, $alpha: 0.3);
            border-radius: 4px;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .content-bottom {
            height: 100%;
          }
        }
        .box-l-b {
          position: relative;
          height: 50%;
           p {
            position: absolute;
            font-size: 10px;
            color: white;
            z-index: 999;
            width: 200px;
            top: -10px;
            background: rgba($color: #303133, $alpha: 0.3);
            border-radius: 4px;
            padding: 0 5px;
            box-sizing: border-box;
          }
          .content-bottom {
            height: 100%;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1650px) and (max-width: 1730px) {
  .electric-quantity {
    .electric-bottom {
    }
  }
}
@media screen and (min-width: 1551px) and (max-width: 1650px) {
  .electric-quantity {
    .electric-bottom {
    }
  }
}
@media screen and (max-width: 1550px) {
  .electric-quantity {
    .right-btn {
      font-size: 12px;
      margin-top: 7px;
      margin-bottom: 7px;
    }
    .electric-bottom {
    }
  }
}
@media screen and (min-width: 1451px) and (max-width: 1550px) {
  .electric-quantity {
    .electric-bottom {
      .electric-bottom-l .cross-h {
        top: 41%;
      }
    }
  }
}
@media screen and (min-width: 1351px) and (max-width: 1450px) {
  .electric-quantity {
    .electric-bottom {
      .electric-bottom-l .cross-h {
        top: 38%;
      }
      .electric-bottom-l .left .l-box-t .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .left .l-box-t .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .right .r-box-t .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .right .r-box-t .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .left .l-box-b .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .left .l-box-b .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .right .r-box-b .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .right .r-box-b .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
    }
  }
}
@media screen and (max-width: 1350px) {
  .electric-quantity {
    .electric-bottom {
      .electric-bottom-l .cross-h {
        top: 38%;
      }
      .electric-bottom-l .left .l-box-t .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .left .l-box-t .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .right .r-box-t .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .right .r-box-t .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .left .l-box-b .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .left .l-box-b .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
      .electric-bottom-l .right .r-box-b .content-top .text {
        font-size: 14px;
      }
      .electric-bottom-l .right .r-box-b .content-top .number {
        font-size: 24px;
        margin-top: 6px;
      }
    }
  }
}
</style>
<style>
.atooltip {
  background: rgba(50, 50, 50, 0.5) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/index/displayScreen/electricQuantityChart.vue